import React from "react";

const pillars = [
  {
    ico: "🎭",
    title: "Socio-cultural",
    text: "Naba Barsha, Rabindra Jayanti, Sports Day and cultural evenings where every member — and their children — can take the stage.",
  },
  {
    ico: "🪔",
    title: "Puja",
    text: "Durga, Lakshmi, Kali and Saraswati Puja, celebrated with the warmth and presence of the whole neighbourhood.",
  },
  {
    ico: "🤝",
    title: "Philanthropic",
    text: "Run with full transparency and compliance, supporting the under-privileged and the unorganised sector around us.",
  },
];

function AboutUs() {
  return (
    <section className="hm-block" id="hm-about">
      <div className="hm-wrap hm-center">
        <span className="hm-eyebrow hm-reveal">Who we are</span>
        <h2 className="hm-reveal">A neighbourhood, bound by celebration</h2>
        <p className="hm-lead hm-reveal">
          Sarjapur Outer Ring Road Bengali Association (SORRBA) was formed in 2008 by the
          Bengali families around the junction of Sarjapur Road and Outer Ring Road — a
          registered non-profit socio-cultural organization that brings like-minded neighbours
          together to cherish a rich cultural heritage, open to people of every walk of life.
        </p>
      </div>
      <div className="hm-wrap">
        <div className="hm-pillars">
          {pillars.map((p) => (
            <div className="hm-card hm-reveal" key={p.title}>
              <div className="hm-card-ico">{p.ico}</div>
              <h3>{p.title}</h3>
              <p>{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
